import clsx from "clsx";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ExpenserTriangle from "../ExpenserTriangle/ExpenserTriangle";
import useMainFilter from "../../hooks/useMainFilter";
import { ICON_SIZES } from "../../helpers/constants";
import useMobile from "../../hooks/useMobile";

interface ILoginFlowLogo {
  rotate?: boolean;
}

const SCROLL_TRIGGER = 50;

const LoginFlowLogo: React.FC<ILoginFlowLogo> = ({ rotate = false }) => {
  const { setMainFilter } = useMainFilter();
  const { isMobile } = useMobile();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      setIsScrolled(scrollY > SCROLL_TRIGGER);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Link
      to="/"
      className={clsx([
        "z-[1000]",
        "flex",
        "flex-row",
        "items-center",
        "gap-1",
        "transition-all",
        "duration-300",
        {
          "fixed top-8 right-10 px-4 py-2 bg-transparent": isScrolled,
          "relative justify-center md:justify-end": !isScrolled,
          "md:[writing-mode:vertical-lr]": rotate,
        },
      ])}
      onClick={() => setMainFilter({ account: "" })}
    >
      <ExpenserTriangle
        size={
          isScrolled
            ? isMobile
              ? ICON_SIZES.SM
              : ICON_SIZES.MD
            : isMobile
            ? ICON_SIZES.LG
            : ICON_SIZES.XL
        }
        className={clsx([
          "transition-all duration-300 text-red-600",
          {
            "rotate-90": rotate,
            "rotate-0": !rotate,
          },
        ])}
      />
      <h1
        className={clsx([
          "font-normal",
          "transition-all",
          "duration-300",
          {
            "text-2xl text-white": isScrolled,
            "text-4xl ": !isScrolled,
            flex: rotate,
          },
        ])}
      >
        eXpenser
        <div className="text-xs text-red-500 inline-flex uppercase items-end md:items-start pb-1 md:pb-0">
          .net
        </div>
      </h1>
    </Link>
  );
};

export default LoginFlowLogo;
